<template>
  <div class="v-login-mobile"
    :class="{ 'error': errorTxt, 'resize': isResize && isNeedAgreement && isNeedSelectAccount }"
  >
    <error-text v-if="errorTxt" :text="errorTxt"></error-text>
    <ul class="v-login-mobile__box">
      <li>
        <div class="label" :class="{ 'active': validMobile }">手机号码</div>
        <input type="text" maxlength="11"
          v-model.trim="form.mobile"
          @focus.stop="focusHideError('mobile')"
          @blur.stop="checkMobile(true)"
          @keyup.stop="dueMobile"
        />
        <quick-clear v-if="useOptions.isQuickClear && form.mobile && focus.mobile"
          @clearTxt="clearMobile"></quick-clear>
        <!-- <error-tips v-if="tips.mobile" :tips="tips.mobile" /> -->
      </li>
      <li v-if="isNeedSelectAccount">
        <div class="label" :class="{ 'active': form.account }">当前账号</div>
        <input :class="{ 'active': form.account }"
          v-model.trim="form.account"
          readonly="true"
        />
        <!-- <error-tips v-if="tips.account" :tips="tips.account"></error-tips> -->
        <change-account
           ref="ChangeAccount"
          @selectItem="selectAccount"
          :items="accountItems"
        ></change-account>
      </li>
      <li class="captcha-li" v-if="isNeedImgCaptcha">
        <div class="captcha-ipt">
          <div class="label" :class="{ 'active': validImgCaptcha }">图形验证码</div>
          <input type="text" maxlength="5"
            v-model.trim="form.imgCaptcha"
            @focus.stop="focusHideError('captcha')"
            @blur.stop="checkImgCaptcha(true)"
            @keyup.stop="dueImgCaptcha"
          />
          <quick-clear v-if="useOptions.isQuickClear && form.imgCaptcha && focus.imgCaptcha"
          @clearTxt="clearImgCaptcha" :right="100"></quick-clear>
          <!-- <error-tips v-if="tips.imgCaptcha" :tips="tips.imgCaptcha" /> -->
        </div>
        <div class="captcha-img" @click="refreshImgCaptcha">
          <img :src="imgCaptchaUrl" alt="" />
        </div>
      </li>
      <li>
        <div class="label" :class="{ 'active': validCode }">短信验证码</div>
        <input type="text" maxlength="6"
          v-model.trim="form.code"
          @focus.stop="focus.code = true;"
          @blur.stop="checkCode(true)"
          @keyup.stop="dueCode"
        />
        <quick-clear v-if="useOptions.isQuickClear && form.code && focus.code"
          :right="100"
          @clearTxt="clearCode"></quick-clear>
        <code-btn :mobile="form.mobile"
          @updateCaptcha="updateCaptcha"
          :imgCaptcha="form.imgCaptcha"
          :account="form.account"
          :isNeedSelectAccount="isNeedSelectAccount"
          :graph="graph"
          @tipImgCaptcha="tipImgCaptcha"
        />
        <!-- <error-tips v-if="tips.code" :tips="tips.code" /> -->
      </li>
      <li class="links-li">
        <login-links
          :env="useOptions.env"
          :loginType="PHONE_TYPE"
          :isRegister="useOptions.isRegister"
          :isFindPwd="useOptions.isFindPwd"
          v-on="$listeners" />
      </li>
      <li class="agreement-li" v-if="isNeedAgreement">
        <agreement :graph="graph" @toggleAgreement="toggleAgreement" />
      </li>
      <li class="btn-li">
        <a class="btn" href="javascript:void(0)"
          :class="{ 'disable': isBtnDisable }"
          @click="toLogin">
          <span v-if="isLoading && useOptions.isBtnStatus">登录中<i class="dot"><b>...</b></i></span>
          <span v-else>登录</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { ENV_API_HOST, PHONE_TYPE } from './libs/constants';
import defaults from './libs/defaults';
import {
  unValidMoblie,
  unValidCode,
  unValidImgCaptcha,
  unValidUserAccount,
  unValidAgreement,
} from './libs/validate';
import { apiLogin, apiUserInfoByMobile, apiAgreement } from './libs/service';
import logger from './libs/logger';
import ChangeAccount from './components/ChangeAccount.vue';
// import ErrorTips from './components/ErrorTips.vue';
import ErrorText from './components/ErrorText.vue';
import Agreement from './components/Agreement.vue';
import CodeBtn from './components/CodeBtn.vue';
import LoginLinks from './components/LoginLinks.vue';
import QuickClear from './components/QuickClear.vue';

export default {
  name: 'v-login-mobile',
  props: {
    options: { type: Object, default: () => ({}) },
    isResize: { type: Boolean, default: false },
  },
  components: {
    ChangeAccount,
    // ErrorTips,
    ErrorText,
    Agreement,
    CodeBtn,
    LoginLinks,
    QuickClear,
  },
  data() {
    return {
      PHONE_TYPE,
      form: {
        mobile: '',
        account: '',
        usernameEncrypt: '',
        code: '',
        imgCaptcha: '',
        loginType: PHONE_TYPE,
        isAgreement: 1,
      },
      tips: {
        mobile: '',
        account: '',
        code: '',
        imgCaptcha: '',
      },
      focus: {
        mobile: false,
        account: false,
        code: false,
        imgCaptcha: false,
      },
      isNeedSelectAccount: false,
      isNeedAgreement: false,
      accountItems: [],
      imgCaptchaUrl: '',
      isLoading: false,
      errorTxt: '',
      isNeedImgCaptcha: false,
    };
  },
  computed: {
    useOptions() {
      return Object.assign({}, defaults, this.options);
    },
    graph() {
      this.refreshImgCaptcha();
      return ENV_API_HOST[this.useOptions.env].graph;
    },
    isBtnDisable() {
      if (!this.useOptions.isBtnStatus) {
        return false;
      }
      if (this.form.mobile
      && this.form.code
      && (!this.isNeedImgCaptcha || (this.isNeedImgCaptcha && this.form.imgCaptcha))
      && (!this.isNeedAgreement || (this.isNeedAgreement && this.form.isAgreement))) {
        return false;
      }
      return true;
    },
    validMobile() {
      return this.focus.mobile || this.form.mobile;
    },
    validImgCaptcha() {
      return this.focus.imgCaptcha || this.form.imgCaptcha;
    },
    validCode() {
      return this.focus.code || this.form.code;
    },
  },
  created() {
    this.refreshImgCaptcha();
  },
  methods: {
    // 去登录
    toLogin() {
      if (this.isBtnDisable || this.isLoading) {
        return;
      }
      const errorTxt = this.checkFormDataError();
      if (errorTxt) {
        this.errorTxt = errorTxt;
        return;
      }
      const data = {
        mobile: this.form.mobile,
        captcha: this.form.code,
        usernameEncrypt: this.form.usernameEncrypt,
        loginType: this.form.loginType,
        isAgreement: this.form.isAgreement,
      };
      this.isLoading = true;
      apiLogin(
        this.graph,
        data,
        (result) => {
          this.isLoading = false;
          this.errorTxt = '';
          // 回调
          if (this.useOptions.loginCallback && typeof this.useOptions.loginCallback === 'function') {
            this.useOptions.loginCallback(result, PHONE_TYPE);
          }
          // 登录成功打点
          logger.event({
            actionType: 'login_success',
            module: this.form.loginType,
          });
        },
        (result) => { // 登录失败
          this.isLoading = false;
          this.errorTxt = result && result.errorMessage ? result.errorMessage : '网络异常，登录失败';
          // 回调
          if (this.useOptions.loginCallback && typeof this.useOptions.loginCallback === 'function') {
            this.useOptions.loginCallback(result, PHONE_TYPE);
          }
          // 登录失败打点
          logger.event({
            actionType: 'login_fail',
            module: this.form.loginType,
            eventLabel: this.errorTxt,
          });
        },
      );
      // 登录按钮点击打点
      logger.click({
        actionType: 'login_btn',
        module: this.form.loginType,
      });
    },
    // 手机号输入处理逻辑
    dueMobile() {
      // 实时校验
      if (this.useOptions.isRealtimeCheck) {
        // this.checkMobile();
        if (!this.form.code) {
          this.tips.code = '';
        }
        if (!this.form.imgCaptcha) {
          this.tips.imgCaptcha = '';
        }
      }
    },
    // 手机验证码输入处理逻辑
    dueCode(e) {
      if (e.keyCode === 13) {
        this.toLogin();
      } else if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkCode();
      }
    },
    // 图片验证码输入处理逻辑
    dueImgCaptcha() {
      if (this.useOptions.isRealtimeCheck) { // 实时校验
        this.checkImgCaptcha();
      }
    },
    // 选择账号回调
    selectAccount(item) {
      this.form.account = item.userNameForShow;
      this.form.usernameEncrypt = item.userName;
    },
    // 登录是否需要协议
    apiNeedAgreement() {
      if (!this.form.mobile) {
        return;
      }
      apiAgreement(
        this.graph,
        this.form.mobile,
        () => { // 需要勾选协议
          this.isNeedAgreement = true;
        },
        () => {
          this.isNeedAgreement = false;
        },
      );
    },
    // 清除信息
    clearMobile() {
      this.form.mobile = '';
      this.tips.mobile = '';
    },
    clearCode() {
      this.form.code = '';
      this.tips.code = '';
    },
    clearImgCaptcha() {
      this.form.imgCaptcha = '';
      this.tips.imgCaptcha = '';
    },
    // 检验数据
    checkFormDataError() {
      const errMobile = unValidMoblie(this.form.mobile);
      const errCode = unValidCode(this.form.code);
      // const errCaptcha = unValidImgCaptcha(this.form.imgCaptcha);
      let errCaptcha = '';
      if (this.isNeedImgCaptcha) {
        errCaptcha = unValidImgCaptcha(this.form.imgCaptcha);
      }
      let errAccount = '';
      if (this.isNeedSelectAccount) {
        errAccount = unValidUserAccount(this.form.account);
      }
      let errAgreement = '';
      if (this.isNeedAgreement) {
        errAgreement = unValidAgreement(this.form.isAgreement);
      }
      return errMobile || errCode || errAccount || errCaptcha || errAgreement;
    },
    checkMobile(isBlur) {
      // this.tips.mobile = unValidMoblie(this.form.mobile);
      if (this.focus.mobile && isBlur === true) {
        setTimeout(() => {
          this.focus.mobile = false;
        }, 200);
        // 如果是手机号，查询对应的账号
        apiUserInfoByMobile(
          ENV_API_HOST[this.useOptions.env].graph,
          this.form.mobile,
          this.form.loginType,
          (result) => { // 登录成功
            if (result && result.length > 1) {
              this.isNeedSelectAccount = true;
              this.accountItems = result;
              this.$nextTick(() => {
                this.$refs.ChangeAccount.selectItem(result[0]);
              });
            } else {
              this.isNeedSelectAccount = false;
              this.accountItems = [];
            }
          },
          () => {
            this.isNeedSelectAccount = false;
            this.accountItems = [];
          },
        );
        // 检查是否需要勾选协议
        this.apiNeedAgreement();
      }
    },
    checkCode(isBlur) {
      // this.tips.code = unValidCode(this.form.code);
      if (this.focus.code && isBlur === true) {
        setTimeout(() => {
          this.focus.code = false;
        }, 200);
      }
    },
    checkImgCaptcha(isBlur) {
      // this.tips.imgCaptcha = unValidImgCaptcha(this.form.imgCaptcha);
      if (this.focus.imgCaptcha && isBlur === true) {
        setTimeout(() => {
          this.focus.imgCaptcha = false;
        }, 200);
      }
    },
    // 刷新图片验证码
    refreshImgCaptcha() {
      this.imgCaptchaUrl = `${ENV_API_HOST[this.useOptions.env].graph}/captcha/getMoblieImgCaptcha?timestamp=${new Date().getTime()}`;
    },
    tipImgCaptcha(msg, isRefresh) {
      this.errorTxt = msg || '';
      if (isRefresh) {
        this.refreshImgCaptcha();
      }
    },
    toggleAgreement(isCheck) {
      this.form.isAgreement = isCheck ? 1 : 0;
    },
    // 账号与图形验证码focus时隐藏错误提示
    focusHideError(type) {
      if (type === 'mobile') {
        this.focus.mobile = true;
      } else {
        this.focus.imgCaptcha = true;
      }
      this.errorTxt = '';
    },
    // 点击获取验证码超过3次时出现图形验证码
    updateCaptcha(res) {
      this.isNeedImgCaptcha = res;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './libs/mixin.scss';

.v-login-mobile {
  font-size: 16px;
  position: relative;
  &.resize {
    li {
      margin-top: 27px;
      &.btn-li {
        margin-top: 20px;
      }
    }
  }
  ul {
    @include resetUl;
  }
  li {
    position: relative;
    margin-top: 34px;
    input {
      @include loginInput;
    }
    .label {
      @include loginLabel;
    }
    &.btn-li {
      margin-top: 30px;
    }
    &.captcha-li {
      @include captchaItem;
    }
    &.links-li,
    &.agreement-li {
      margin-top: 10px;
    }
  }
  .btn {
    @include loginBtn;
    width: 180px;
    margin: 0 auto;
    .dot {
      @include dotAni;
    }
  }
  .show-pwd {
    @include imgSprites(-5px, -97px);
    position: absolute;
    right: 0;
    top: 16px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    z-index: 3;
    &.on {
      background-position: -97px -57px;
    }
  }
}
</style>
